import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from '../../components';
import { handleModal } from "../../redux/actions/modals";
import { toastConfig } from '../../redux/actions/toast';
import { updateActiveWatchlist, updateOpenWatchlist, updatedDashboardWatchlist } from '../../redux/actions/watchlist';
import { deepClone, getAppInfoData, returnCountWithPad } from '../../utils/global_functions';
import { APP_INFO_PARAMS, DONT_MISS_WATCHLIST_NAME, MY_HOLDINGS_WATCHLIST_NAME } from '../../utils/global_variables';
import { _allWatchlistOpened } from "../../controllers";
import { selectScripForDelete } from '../../redux/actions/watchlist';
import { uniqBy } from 'lodash';

const ChooseWatchlistModal = (props) => {
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
    const { setIsSuppressMenu, handleAllFunctions, setScripDetails, setBIsShowDeleteCheckBox, setBIsShowSortHandle, setBisReordered } = props;
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const watchlists = useSelector(state => state.watchList.watchlists);
    const openWatchlists = useSelector(state => state.watchList.openWatchlists);
    const appInfo = useSelector(state => state.appInfo.appInfo);
    const maxWatchlistLength = useMemo(() => getAppInfoData(APP_INFO_PARAMS.APP_MAX_PROFILE_COUNT, appInfo), [appInfo]);
    const filteredWatchList = useMemo(() => {

        let arrWatchlists = deepClone(watchlists);
        let arrOpenWatchlists = deepClone(openWatchlists);

        if (arrWatchlists && arrWatchlists?.length > 0) {
            return arrWatchlists?.filter(elem => !arrOpenWatchlists.find(obj => { return elem?.id === obj?.id; }));
        } else {
            return [];
        }
    }, [watchlists, openWatchlists]);

    const [selectedWatchListId, setSelectedWatchListId] = useState(null);

    //Ameersha N - BT-95888 -Create Watchlist - 26-02-2024  --Start
    let topSorted = useMemo(() => {
        if (filteredWatchList?.length > 0) {
            const withoutDefaultAndDontMissAndDefault = filteredWatchList?.filter(eachWatchlist => (eachWatchlist?.sWatchListName !== DONT_MISS_WATCHLIST_NAME?.toUpperCase() && eachWatchlist?.sWatchListName !== MY_HOLDINGS_WATCHLIST_NAME?.toUpperCase() && !eachWatchlist?.bIsDefault));
            const withDefaultAndDontMissAndDefault = filteredWatchList?.filter(eachWatchlist => (eachWatchlist?.sWatchListName === DONT_MISS_WATCHLIST_NAME?.toUpperCase() || eachWatchlist?.sWatchListName === MY_HOLDINGS_WATCHLIST_NAME?.toUpperCase()))?.concat(withoutDefaultAndDontMissAndDefault);
            const defatWatchlist = filteredWatchList?.filter(eachWatchlist => (eachWatchlist?.bIsDefault));
            let final = uniqBy(defatWatchlist?.concat(withDefaultAndDontMissAndDefault),(item)=>item.id);
            return final;
        } else {
            return [];
        }

    }, [filteredWatchList]);
    //Ameersha N - BT-95888 -Create Watchlist - 26-02-2024  --End

    useEffect(() => {
        if (topSorted?.length > 0) {
            setSelectedWatchListId(topSorted[0]?.id);
        }
    }, [topSorted]);
    // Ameersha N | BT-95888 Create Watchlist Feature start
    const onAddWatchlistTab = useCallback((nWatchlistId) => {
        let allWatchlistOpened = _allWatchlistOpened(watchlists, openWatchlists);

        if (!allWatchlistOpened.status) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: allWatchlistOpened?.message }));
        } else {
            handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
            const objWatchlist = deepClone(watchlists).find(each => each.id === nWatchlistId);
            if (objWatchlist && Object.keys(objWatchlist).length > 0) {
                handleAllFunctions('HANDLE_MANAGE_COLUMNS', objWatchlist);
                setScripDetails([]);
                dispatch(updateOpenWatchlist([...openWatchlists, { ...objWatchlist }]));
                dispatch(updateActiveWatchlist({ ...objWatchlist }));
                dispatch(updatedDashboardWatchlist({ ...objWatchlist })); //Vaibhav Singh: 08-09-2023 : Update Dashboard Watchlist
                // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
                setBIsShowDeleteCheckBox(false);
                setBIsShowSortHandle(false);
                setBisReordered(false);
                dispatch(selectScripForDelete([]));
                // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 


                setTimeout(() => {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `${objWatchlist?.sWatchListName} (${returnCountWithPad(objWatchlist?.scrips?.length)}) has been added to the view`, }));

                }, 100);
            } else { }
            dispatch(handleModal([{ 'CHOOSE_WATCHLIST_MODAL': false }]));
            setIsSuppressMenu(true);
            let filterElment = document?.getElementById('watchlist_header_search');
            filterElment.value = null;
        }

    }, [handleAllFunctions, setScripDetails, setIsSuppressMenu, dispatch, watchlists, openWatchlists, setBIsShowDeleteCheckBox]);
    // Ameersha N | BT-95888 Create Watchlist Feature end


    // Ameersha N | BT-95888 Create Watchlist Feature start
    const onHide = () => {
        dispatch(handleModal([{ 'CHOOSE_WATCHLIST_MODAL': false }]));
    };
    // Ameersha N | BT-95888 Create Watchlist Feature end


    // Ameersha N | BT-95888 Create Watchlist Feature start
    const handleDelete = (each, e) => {
        handleAllFunctions('DELETE_WATCHLIST', each, e);
    };
    // Ameersha N | BT-95888 Create Watchlist Feature end

    return (
        <BzModal show={modals['CHOOSE_WATCHLIST_MODAL']} onHide={onHide} centered className='p-3'>
            <BzModalHeader className='modaltabs-header bdr-none'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size4 color-text'>Choose Watchlist</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 mb-3'>
                        <Col>
                            <div className='font-regular font-size3 color-text'>You can change the watchlist from the dropdown later</div>
                        </Col>
                    </Row>
                    {topSorted?.map((each, i) => (
                        <Row className='g-0 mb-3 align-items-center' key={i}>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <div className='form-check'>
                                    <input className='form-check-input cursor-pointer' type="radio" name="chooseWatchlist" checked={selectedWatchListId === each?.id} value={each?.id} id={each?.id} onChange={() => setSelectedWatchListId(each?.id)} />
                                    <label className={`font-medium font-size2 cursor-pointer ${each?.id === selectedWatchListId ? 'color-text' : 'color-subtext'}`} htmlFor={each?.id}>{each?.sWatchListName} ({returnCountWithPad(each?.scrips?.length)})</label>
                                </div>
                            </Col>
                            {each?.bIsDefault || each?.sWatchListName?.toLowerCase() === DONT_MISS_WATCHLIST_NAME || each?.sWatchListName?.toLowerCase() === MY_HOLDINGS_WATCHLIST_NAME ? null :
                                <Col md={1} className='d-flex justify-content-end align-items-center'>
                                    <div className='icon-16 icon-delete icon-dark' onClick={handleDelete.bind(this, each)}></div>
                                </Col>}
                        </Row>
                    ))}
                    <Row className='g-0 mt-3'>
                        <Col className='f-flex justify-content-start align-items-center'>
                            <div className='d-flex d-inline-block align-items-center cursor-pointer' onClick={() => handleAllFunctions('HANDLE_CREATE_NEWWATCHLIST_OPTION')}>
                                {/* //Ameersha N : 22-11-2023 : BT-95888 - Breeze - Create Watchlist - issue changed black color text to primary color -Start */}
                                <div className='icon-12 icon-add background-textual-link-withicon me-2'></div>
                                {/* //Ameersha N : 22-11-2023 : BT-95888 - Breeze - Create Watchlist - issue changed black color text to primary color -End */}
                                <div className='font-medium font-size2 color-textual-link-withicon p-t-3'>Create new watchlist ({watchlists?.length}/{maxWatchlistLength})</div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter className='bdr-none'>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0'>
                        <Col md={8} className='mrgauto d-flex'>
                            <BzButton className='btn btn-md btn-outline btn-block text-uppercase me-3' onClick={onHide}>CANCEL</BzButton>
                            <BzButton className='btn btn-md btn-primary btn-block text-uppercase ms-3' onClick={() => onAddWatchlistTab(selectedWatchListId)}>ADD</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(ChooseWatchlistModal);